import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IApiGetLiveStreamsItemResponseBody } from '~/lib/api/modules/LiveStreams';
import { ContentBlock } from '~/components/molecules/ContentBlock';

export type ILiveStreamInfoProps = IContainerProps & {
  liveStream: IApiGetLiveStreamsItemResponseBody;
};

export const LiveStreamInfo: React.FC<ILiveStreamInfoProps> = (props) => {
  const { sx, liveStream } = props;
  const { t, i18n } = useTranslation();

  const ended = !!liveStream.expired;
  const started =
    !ended &&
    liveStream.startDateTime &&
    DateTime.fromISO(liveStream.startDateTime) <= DateTime.now();
  const programmed = !ended && !started;

  return (
    <ContentBlock sx={sx}>
      <ContentBlock.Title>{t('LiveStreamInfo.title')}</ContentBlock.Title>

      <ContentBlock.InfoList>
        <ContentBlock.InfoListItem
          label={t('LiveStreamInfo.fields.state.label')}
        >
          {/* TODO: use a colored badge */}
          {ended
            ? t('LiveStreamInfo.fields.state.values.expired')
            : programmed
              ? t('LiveStreamInfo.fields.state.values.programmed')
              : t('LiveStreamInfo.fields.state.values.ready')}
        </ContentBlock.InfoListItem>

        {liveStream.startDateTime && (
          <ContentBlock.InfoListItem
            label={t('LiveStreamInfo.fields.startDateTime.label')}
          >
            {DateTime.fromISO(liveStream.startDateTime).toLocaleString(
              DateTime.DATETIME_FULL,
              { locale: i18n.language },
            )}
          </ContentBlock.InfoListItem>
        )}

        {liveStream.expireDateTime && (
          <ContentBlock.InfoListItem
            label={t('LiveStreamInfo.fields.expireDateTime.label')}
          >
            {DateTime.fromISO(liveStream.expireDateTime).toLocaleString(
              DateTime.DATETIME_FULL,
              { locale: i18n.language },
            )}
          </ContentBlock.InfoListItem>
        )}
      </ContentBlock.InfoList>
    </ContentBlock>
  );
};
